import React from 'react'
import { ToastContainer } from 'react-toastify'
import RightSidebar from '../Components/Sidebar/RightSidebar'
import UserSidebar from '../Components/Sidebar/UserSidebar'
import Topbar from '../Components/Topbar/Topbar'

export default function LoginLayout({children}) {
  return (
    <section className='layout-container'>
      <div className='container-fluid'>
        <div className='row g-0'>
          <div className='col-lg-3 col-md-12'>
            <UserSidebar />
          </div>
          <div className='col-lg-6 col-md-12 pe-lg-4 pe-md-0'>
            {children}
          </div>
          <div className='col-lg-3 col-md-12'>
            <Topbar />
            <RightSidebar />
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  )
}
